<template>
  <div class="container box">

    <h1 class="is-size-3">Release Notes</h1>

    <h2 class="is-size-4">January 11, 2023 (version 2.0.17)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes flight search form error when selecting a specific time of day.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 2, 2022 (version 2.0.16)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes flight search form error when choosing a city instead of an airport.</li>
        <li>Fixed: Fixes payment method selection when in Gant Together mode.</li>
      </ul>
    </div>

    <h2 class="is-size-4">October 10, 2022 (version 2.0.15)</h2>

    <div class="content">
      <ul>
        <li>Added: Adds support for multi-select registration questions in the Gant Together registration form and post event survey form.</li>
        <li>Added: Adds the ability to enable/disable personal travel bookings by account.</li>
        <li>Fixed: Fixes an issue when auto-reloading the newest TripCircuit version when one certain pages in Gant Together mode.</li>
      </ul>
    </div>

    <h2 class="is-size-4">September 26, 2022 (version 2.0.14)</h2>

    <div class="content">
      <ul>
        <li>Added: Automatically attempts to load the newest version of TripCircuit when visiting log in page or starting Gant Together registration.</li>
        <li>Added: Adds support for radio button questions in Gant Together registration.</li>
        <li>Improved: Refactors flight result filters.</li>
        <li>Fixed: Fixes issue when one of the flight search results has an error.</li>
      </ul>
    </div>


    <h2 class="is-size-4">September 15, 2022 (version 2.0.13)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug affecting flight search results quality when booking on behalf of someone else.</li>
      </ul>
    </div>

    <h2 class="is-size-4">September 13, 2022 (version 2.0.12)</h2>

    <div class="content">
      <ul>
        <li>Improved: Redesigned flight search form display when on a mobile device, continued.</li>
      </ul>
    </div>

    <h2 class="is-size-4">September 12, 2022 (version 2.0.11)</h2>

    <div class="content">
      <ul>
        <li>Improved: Redesigned flight search form display when on a mobile device.</li>
        <li>Improved: Redesigned hotel results display when on a mobile device.</li>
        <li>Improved: Loads hotel rate/cancellation policy details in line instead of in a modal window.</li>
        <li>Fixed: Fixes issue when choosing a flight when in search by price mode.</li>
      </ul>
    </div>

    <h2 class="is-size-4">September 2, 2022 (version 2.0.10)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes trip details display when in approvals mode and Gant Together mode.</li>
      </ul>
    </div>

    <h2 class="is-size-4">August 26, 2022 (version 2.0.9)</h2>

    <div class="content">
      <ul>
        <li>Added: Adds the ability to view trips for your travelers.</li>
        <li>Added: Re-enables the ability to book same day travel.</li>
        <li>Improved: Redesigned airport search auto-complete form for speed increases and options tailored to Gant travelers.</li>
        <li>Improved: Improved security measures.</li>
        <li>Fixed: Fixed various bugs.</li>

      </ul>
    </div>

    <h2 class="is-size-4">August 24, 2022 (version 2.0.8)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes issue affecting hotel bookings.</li>
      </ul>
    </div>

    <h2 class="is-size-4">August 16, 2022 (version 2.0.7)</h2>

    <div class="content">
      <ul>
        <li>Added: Includes additional air content by performing a separate search for preferred carriers.</li>
        <li>Fixed: Fixes bug in air results by price sort order.</li>
      </ul>
    </div>

    <h2 class="is-size-4">August 12, 2022 (version 2.0.6)</h2>

    <div class="content">
      <ul>
        <li>Added: Ability to filter hotel results by chain.</li>
        <li>Improved: Improves hotel results loading speed and eliminates issue of incorrect preview price being shown.</li>
        <li>Improved: Includes more trip details on trip approval page and in Trip approval email.</li>
        <li>Fixed: Fixes bug on multi-leg air searches.</li>
        <li>Fixed: Max travel date picker range.</li>
      </ul>
    </div>


    <h2 class="is-size-4">August 2, 2022 (version 2.0.5)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug on Gant Together flight search form destination airport bug.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 31, 2022 (version 2.0.4)</h2>

    <div class="content">
      <ul>
        <li>Improved: Re-enables additional flight options to be loaded when viewing results by schedule.</li>
        <li>Fixed: Fixes bug on Gant Together registration confirmation page.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 28, 2022 (version 2.0.3)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug to hide flight results based on travel policy.</li>
        <li>Fixed: Fixes bug to show Out of Policy tag when applicable.</li>
        <li>Fixed: Fixes issue where reporting questions (UDIDs) are not conditionally shown on checkout page.</li>
        <li>Fixed: Fixes search by schedule mix up.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 23, 2022 (version 2.0.2)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes meeting confirmation page bug.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 22, 2022 (version 2.0.1)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug affecting cabin class searches.</li>
        <li>Fixed: Fixes bug affecting cabin class options for Gant Together meetings.</li>
        <li>Fixed: Fixes bug affecting date of birth field on checkout page when the value doesn't already exist on the travel profile.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 14, 2022 (version 2.0.0)</h2>

    <div class="content">
      <ul>
        <li>Added: Adds ability to cancel and modify reservations.</li>
        <li>Added: Adds new trip details page to display more details about an upcoming trip.</li>
        <li>Added: Adds ability to view flight search results by schedule in addition to by price.</li>
        <li>Improved: Improves user interface throughout the application.</li>
        <li>Improved: Improves application stability through a code refactor.</li>
        <li>Fixed: Fixes various bugs.</li>
      </ul>
    </div>

    <h2 class="is-size-4">March 3, 2022 (version 1.1.11)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes a bug in the GantTogether flight search form that was switching preferred flight times.</li>
      </ul>
    </div>

    <h2 class="is-size-4">January 18, 2022 (version 1.1.10)</h2>

    <div class="content">
      <ul>
        <li>Added: Replaces "Select" button with a message to call an agent to book travel if it starts within the next 4 hours (air and car only).</li>
        <li>Added: Adds warning message for travel that starts within the next 24 hours (air, car, and hotel).</li>
        <li>Improved: Includes more hotel cancellation policy details in both the search results view and in the rate details pop up area.</li>
      </ul>
    </div>


    <h2 class="is-size-4">January 3, 2022 (version 1.1.9)</h2>

    <div class="content">
      <ul>
        <li>Added: Adds additional validation to meeting attendee profile form during registration process.</li>
        <li>Added: Enables cabin selector in air search form for all travel types. Available cabin options can be configured by travel policy.</li>
        <li>Added: Displays error messages when an air search fails.</li>
        <li>Changed: Changes date range for meeting travel to include all dates between meeting start and meeting end.</li>
        <li>Changed: Restricts seat map data to only current booking class.</li>
        <li>Fixed: Turns off meeting registration access when outside of registration window.</li>
        <li>Fixed: Turns off post event survey if a survey isn't set up for a particular meeting.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 13, 2021 (version 1.1.8)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug when applying GantTogether-specific travel policy to booking.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 13, 2021 (version 1.1.7)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug where email CC checkbox is mistakenly shown when performing a GantTogether booking for yourself.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 13, 2021 (version 1.1.6)</h2>

    <div class="content">
      <ul>
        <li>Improved: Adds the ability to conditionally show reporting questions based on whether you are in standard booking mode or GantTogether booking mode.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 10, 2021 (version 1.1.5)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug when applying GantTogether-specific travel policy to search and booking.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 10, 2021 (version 1.1.4)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug on GantTogether flight search page when there are multiple preferred airports.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 8, 2021 (version 1.1.3)</h2>

    <div class="content">
      <ul>
        <li>Added: Adds trip type to bookings so we can exclude personal trips from trip approvals.</li>
        <li>Improved: Displays additional trip details when viewing upcoming trips or while reviewing a trip for approval.</li>
      </ul>
    </div>

    <h2 class="is-size-4">December 7, 2021 (version 1.1.2)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes formatting on date picker when in Gant Together mode.</li>
        <li>Fixed: Fixes signature pad field in Gant Together mode.</li>
      </ul>
    </div>


    <h2 class="is-size-4">November 16, 2021 (version 1.1.1)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes bug on My Trips page that causes loading screen to stay visible if there are no trips to display.</li>
      </ul>
    </div>

    <h2 class="is-size-4">November 5, 2021 (version 1.1.0)</h2>

    <div class="content">
      <ul>
        <li>Added: Adds support for Gant Together meeting registration and booking. Supports managing attendee profile details, registration questions, booking air, car, and hotel, post-event surveys, and more.</li>
        <li>Added: Adds custom meeting access point for clients that won't be sending event registration invitations via email.</li>
      </ul>
    </div>

    <h2 class="is-size-4">October 14, 2021 (version 1.0.15)</h2>

    <div class="content">
      <ul>
        <li>Improved: Improves seatmap data and shows brand names for chargeable seats.</li>
        <li>Improved: Improves hotel chain code to name translation.</li>
        <li>Fixed: Fixes bug affecting searching hotels by chain.</li>
      </ul>
    </div>

    <h2 class="is-size-4">October 6, 2021 (version 1.0.14)</h2>

    <div class="content">
      <ul>
        <li>Added: Adds on-time performance data to flight search results.</li>
        <li>Added: Stores details about the person booking the trip so they receive a copy of the booking confirmation email.</li>
        <li>Improved: Expanded the location search autocomplete feature to include establishments and points of interest.</li>
        <li>Fixed: Fixes bug affecting bookings that violate travel policy but don't require approval.</li>
      </ul>
    </div>

    <h2 class="is-size-4">September 23, 2021 (version 1.0.13)</h2>

    <div class="content">
      <ul>
        <li>Added: Customized hotel rates based on traveler's travel programs and eligibility for discounts for seniors, military, government, etc.</li>
        <li>Added: Adds ability to enter email addresses to CC on trip itinerary emails.</li>
        <li>Added: Adds ability to configure an email address CC at the travel policy level to receive all trip itinerary emails.</li>
        <li>Improved: Travel programs list on checkout page now works with related chains.</li>
        <li>Improved: Trip "Add to Calendar" event details.</li>
        <li>Improved: Minimum and maximum travel dates are now dynamically calculated.</li>
        <li>Removed: My Profile link from mobile version of home screen.</li>
      </ul>
    </div>

    <h2 class="is-size-4">September 3, 2021 (version 1.0.12)</h2>

    <div class="content">
      <ul>
        <li>Added: Flight cabin selector for personal trips.</li>
        <li>Improved: Shows cabin name instead of cabin code in flight search results.</li>
        <li>Removed: Rental car location type tooltip that was causing confusion.</li>
        <li>Removed: My Profile section is no longer used. The same functionality and more is available on the Gateway website/app.</li>
      </ul>
    </div>

    <h2 class="is-size-4">August 27, 2021 (version 1.0.11)</h2>

    <div class="content">
      <ul>
        <li>Added: Product analytics to improve user experience.</li>
      </ul>
    </div>

    <h2 class="is-size-4">August 19, 2021 (version 1.0.10)</h2>

    <div class="content">
      <ul>
        <li>Improved: Reloading of app when newer version is available.</li>
      </ul>
    </div>

    <h2 class="is-size-4">August 16, 2021 (version 1.0.9)</h2>

    <div class="content">
      <ul>
        <li>Improved: Switch CDN that we use to host airline logos.</li>
      </ul>
    </div>

    <h2 class="is-size-4">August 12, 2021 (version 1.0.8)</h2>

    <div class="content">
      <ul>
        <li>Feature: Adds support for same day round trips.</li>
        <li>Feature: Rental car results now have more descriptive display names.</li>
        <li>Fixed: Various bugs.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 19, 2021 (version 1.0.7)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Various bugs.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 8, 2021 (version 1.0.6)</h2>

    <div class="content">
      <ul>
        <li>Feature: Date selectors are now auto-populated with dates of already chosen segments.</li>
        <li>Feature: Adds ability to collect guest traveler's middle name to ensure name matches goverment issued ID.</li>
        <li>Feature: Adds ability to enter special requests to an agent with your booking.</li>
        <li>Fixed: Various bugs.</li>
      </ul>
    </div>

    <h2 class="is-size-4">July 6, 2021 (version 1.0.5)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Bug stopping use of American Express credit card.</li>
        <li>Fixed: Bug stopping use of credit card that expires during the current month.</li>
      </ul>
    </div>

    <h2 class="is-size-4">June 21, 2021 (version 1.0.4)</h2>

    <div class="content">
      <ul>
        <li>Feature: Mobile friendly user interface.</li>
        <li>Feature: Hide main menu until logged in.</li>
        <li>Feature: Add ability to undo response to custom reporting questions.</li>
        <li>Feature: Add more options to choose existing travel dates when search for more segments.</li>
      </ul>
    </div>


    <h2 class="is-size-4">June 15, 2021 (version 1.0.3)</h2>

    <div class="content">
      <ul>
        <li>Feature: Currency conversion to USD for hotels outside of U.S.</li>
        <li>Fixed: Multi-leg flight searches using city code.</li>
      </ul>
    </div>

    <h2 class="is-size-4">June 7, 2021 (version 1.0.2)</h2>

    <div class="content">
      <ul>
        <li>Feature: Enhanced travel policy configuration.</li>
      </ul>
    </div>

    <h2 class="is-size-4">May 20, 2021 (version 1.0.1)</h2>

    <div class="content">
      <ul>
        <li>Various bug fixes and improvements.</li>
      </ul>
    </div>


    <h2 class="is-size-4">May 17, 2021 (version 1.0.0)</h2>

    <div class="content">
      <ul>
        <li>Initial public release.</li>
      </ul>
    </div>

    <h2 class="is-size-4">May 5, 2021 (version 0.0.9)</h2>

    <div class="content">
      <ul>
        <li>Feature: Adds ability to sort flight results by rating.</li>
        <li>Feature: Adds ability to search flights by city.</li>
        <li>Feature: Hides unused ticket messages and filters when none are available.</li>
        <li>Fixed: Fixes various bugs.</li>
      </ul>
    </div>

    <h2 class="is-size-4">April 29, 2021 (version 0.0.8)</h2>

    <div class="content">
      <ul>
        <li>Feature: Shows Itinerary summary on search results pages.</li>
        <li>Feature: Adds ability to download trip details to .ics calendar.</li>
        <li>Feature: Adds ability to sort hotels by proximity to searched location.</li>
        <li>Feature: Displays distance from search location in hotel results.</li>
        <li>Feature: Hides reporting questions on checkout page for personal trips.</li>
      </ul>
    </div>

    <h2 class="is-size-4">April 20, 2021 (version 0.0.7)</h2>

    <div class="content">
      <ul>
        <li>Feature: Adds customized flight ratings to results.</li>
        <li>Feature: Displays airport city and state information alongside three letter airport code.</li>
        <li>Feature: Changes display of car rental locations.</li>
      </ul>
    </div>


    <h2 class="is-size-4">April 13, 2021 (version 0.0.6)</h2>

    <div class="content">
      <ul>
        <li>Feature: Adds the ability to control which payment methods are available for use depending on the traveler and type of travel.</li>
        <li>Feature: Adds automatic log out timer and data refresh time to ensure accurate pricing and availability.</li>
        <li>Feature: Adds the ability to preview a seatmap from the search results page.</li>
        <li>Fixed: Fixes various bugs.</li>
      </ul>
    </div>


    <h2 class="is-size-4">April 4, 2021 (version 0.0.5)</h2>

    <div class="content">
      <ul>
        <li>Feature: Adds the ability to book travel for other travelers within your organization or for guest travelers.</li>
        <li>Feature: Adds the ability to book personal travel.</li>
        <li>Feature: Adds the ability to view a seatmap and select seats for your flights.</li>
        <li>Feature: Adds single sign functionality for GantGateway.com.</li>
        <li>Fixed: Fixes various bugs, text formatting and other UI changes.</li>
      </ul>
    </div>

    <h2 class="is-size-4">March 3, 2021 (version 0.0.4)</h2>

    <div class="content">
      <ul>
        <li>Feature: Adds the ability to search hotels by chain and rating.</li>
        <li>Feature: Adds the ability to search cars by provider.</li>
        <li>Feature: Adds the ability to filter results according to travel policy compliance.</li>
        <li>Feature: Adds the ability to view hotel search results on a map.</li>
        <li>Improved: Improves the user interface for multi-leg flight searchs.</li>
        <li>Improved: Adds a minimum price option to the price selector/slider.</li>
        <li>Fixed: Fixes various bugs to improve performance.</li>
      </ul>
    </div>

    <h2 class="is-size-4">Feb 24, 2021 (version 0.0.3)</h2>

    <div class="content">
      <ul>
        <li>Fixed: Fixes issue of missing credit card logo files.</li>
      </ul>
    </div>

    <h2 class="is-size-4">Feb 17, 2021 (version 0.0.2)</h2>

    <div class="content">
      <ul>
        <li>Improved: Increases default number of search results displayed.</li>
      </ul>
    </div>

    <h2 class="is-size-4">Feb 10, 2021 (version 0.0.1)</h2>

    <div class="content">
      <ul>
        <li>Initial release</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ReleaseNotes',
}
</script>

<style scoped>
</style>
